module.exports = __webpack_public_path__ + "static/media/tb_app_icon_view.8eeddc3e.svg";